var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1326_6668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2389 20.2265H4.19536C3.98178 20.2265 3.80862 20.3997 3.80862 20.6133C3.80862 20.8269 3.98178 21 4.19536 21H17.2389C17.4525 21 17.6256 20.8269 17.6256 20.6133C17.6256 20.3997 17.4525 20.2265 17.2389 20.2265Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39732 15.9045L4.8504 16.4514L6.73982 18.3408L7.28674 17.7939L5.39732 15.9045Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7216 5.01535L18.1761 3.46985C17.5496 2.84341 16.5303 2.84344 15.9039 3.46985L15.1328 4.24093C14.9809 4.11731 14.7571 4.12624 14.6156 4.26775L13.2654 5.61792C13.124 5.75939 13.115 5.98321 13.2386 6.13512L5.52943 13.8443C5.48667 13.8871 5.45454 13.9393 5.43559 13.9967L3.82807 18.875C3.78237 19.0136 3.81865 19.1662 3.92191 19.2695C3.99563 19.3432 4.09446 19.3827 4.19543 19.3827C4.2359 19.3827 4.27672 19.3764 4.31641 19.3633L9.19473 17.7558C9.25218 17.7369 9.30439 17.7047 9.34714 17.6619L17.0563 9.95276C17.1271 10.0104 17.2136 10.0392 17.3 10.0392C17.399 10.0392 17.498 10.0015 17.5735 9.92594L18.9237 8.57577C19.0651 8.4343 19.0741 8.21048 18.9505 8.0586L19.7216 7.28752C20.348 6.66108 20.348 5.64179 19.7216 5.01535ZM4.80268 18.3887L5.97361 14.8354L8.35604 17.2178L4.80268 18.3887ZM9.07368 16.8415L6.34983 14.1177L13.7841 6.68348L16.5079 9.40733L9.07368 16.8415ZM17.3 9.10557L14.0858 5.89134L14.8891 5.08809L18.1033 8.30232L17.3 9.10557ZM19.1746 6.74057L18.405 7.51021L15.6812 4.78637L16.4508 4.01673C16.7757 3.69187 17.3043 3.6919 17.6291 4.01673L19.1746 5.56223C19.4995 5.88712 19.4995 6.41572 19.1746 6.74057Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1326_6668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.89611db064acd11150fbd767573f83c5.svg";
export { ForwardRef as ReactComponent };